
// Libraries
import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from 'moment';


// Local Libraries
import { gisRoutes } from '../../routes/routes';
import phrasebookLoad from "../../i18n";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util"
import { OnClickButton } from "../../components/SkyFramework/Buttons";
import { DatePicker } from "../../components/SkyFramework/DatePicker/DatePicker";

// Redux
import { vendorActions, filedownloadActions, reportActions, callActions, alertActions } from 'actions';

// Components
import { Table } from "../../components/SkyFramework/Tables/Table";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton } from "../../components/SkyFramework/Buttons/SubmitButton";
import { SearchBox } from "../../components/SkyFramework/Search";
import { PaginationBar } from "../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { Area, AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, Sector } from 'recharts';



// Constants
const phrasebook = phrasebookLoad()

class SummaryOverview extends PureComponent {
  constructor(props) {
    super(props);

    let dateToday = new Date();


    this.state = {
      category: 'calls',
      name: 'callstatistics',
      report: undefined,

      service_types: [{ value: 'ITFS', label: 'ITFS' }, { value: 'UIFN', label: 'UIFN' }, { value: 'DID', label: 'DID' }, { value: 'SIP Trunking', label: 'SIP Trunking' }],
      customers: undefined,
      jurisdictions: undefined,
      cities: undefined,
      periods: [{ value: 7, label: '7 days' }, { value: 14, label: '14 days' }, { value: 30, label: '30 days' }, { value: 90, label: '90 days' }],
      directions: [{ value: 'INBOUND', label: 'Inbound' }, { value: 'OUTBOUND', label: 'Outbound' }],
      minmax: [],
      customer_code: token.loggedProperty('customer_code'),
      dateToday: dateToday,
      jurisdiction: undefined,
      toDate: moment(new Date),
      fromDate: moment(new Date).subtract(1, 'days'),
      period: 7,
      direction: undefined,
      filters: {},
      toggleData: false,
      limit: 10,
      page: 0

    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePickerChange = this.handlePickerChange.bind(this);
    this.onPieEnter = this.onPieEnter.bind(this);
    this.ToggleButton = this.ToggleButton.bind(this);
    this.handleStatsSearch = this.handleStatsSearch.bind(this);

  }

  handleStatsSearch() {
    var format = 'YYYY-MM-DD';
    var searchValues = {
      customer_code: this.state.customer_code,
      jurisdiction: this.state.jurisdiction,
      direction: this.state.direction,
      toDate: moment(this.state.toDate).format(format),
      fromDate: moment(this.state.fromDate).format(format),
    };
    this.setState({ report: undefined });
    this.setState({ minmax: [] });
    this.setState({ filters: searchValues });
    this.props.dispatch(reportActions.get(this.state.category, this.state.name, searchValues));
  }

  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  calculateMinMax(values) {
    var minmaxval = {
      callattempts: { min: 0, max: 0 },
      successfulcalls: { min: 0, max: 0 },
      minutes: { min: 0, max: 0 },
      aloc: { min: 0, max: 0 },
      asr: { min: 0, max: 0 },
      ner: { min: 0, max: 0 },
      pdd: { min: 0, max: 0 },
    };
    var keys = Object.keys(minmaxval);
    values.map(datedata => {
      keys.map(key => {
        if (minmaxval[key].min == 0) {
          minmaxval[key].min = parseInt(datedata[key]);
        }
        else if (parseInt(datedata[key]) < parseInt(minmaxval[key].min)) {
          minmaxval[key].min = parseInt(datedata[key]);
        }

        if (minmaxval[key].max == 0) {
          minmaxval[key].max = parseInt(datedata[key]);
        }
        else if (parseInt(datedata[key]) > parseInt(minmaxval[key].max)) {
          minmaxval[key].max = parseInt(datedata[key]);
        }
      })
      console.log(minmaxval);
    })
    return minmaxval;
  }

  calculateTicks(minmax) {
    if (minmax.min == minmax.max) return [minmax.min / 4, minmax.min / 2, minmax.min, minmax.min + minmax.min / 4];
    else return [minmax.min / 2, minmax.min, (minmax.min + (minmax.max - minmax.min) / 2), minmax.max, (minmax.max + (minmax.max - minmax.min) / 2)];
  }

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(vendorActions.getAll(0, this.state.page, { orderby: 'name', asc: true }));
    }
    // this.props.dispatch(georesourceActions.getCountries(null, 1000));
    this.props.dispatch(callActions.getJurisdictions());
    this.props.dispatch(callActions.getCities());
    this.handleStatsSearch();
  }


  componentDidUpdate(prevProps) {
    if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
      this.setState({ customers: this.props.customers.data });
    }
    if (this.props.report && prevProps && prevProps.report !== this.props.report) {
      this.setState({ report: this.props.report });
      this.setState({ minmax: this.calculateMinMax(this.props.report) });
    }
    if (this.props.cities && prevProps && prevProps.cities !== this.props.cities) {
      this.setState({ cities: this.props.cities });
    }
    if (this.props.jurisdictions && prevProps && prevProps.jurisdictions !== this.props.jurisdictions) {
      this.setState({ jurisdictions: this.props.jurisdictions });


    }
  }
  handlePickerChange = (id) => (date) => {
    if (id == 'fromDate') {
      if (date > this.state.toDate) alertActions.error('Please select a date before the `To date` ');
      else this.setState({ [id]: date });
    } else if (id == 'toDate') {
      if (date < this.state.fromDate) alertActions.error('Please select a date after the `From date` ');
      else this.setState({ [id]: date });
    }
  }


  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.handleStatsSearch();

  }

  handleDownload = (e) => {
    e.preventDefault();
    this.props.dispatch(filedownloadActions.add('calls', 'callstatistics', this.state.limit, 0, this.state.filters));

  }

  SearchBox() {

    if (this.state.jurisdictions && this.state.cities) {
      if (token.loggedAccountType() < 200 && this.state.customers) {
        const customerOptions = this.state.customers.map(function (customer) {
          return { value: customer['pccwglobal_insight_company_code'] ? customer['pccwglobal_insight_company_code'] : customer['name'], label: capitalizeFirstLetter(customer['name']) };
        });
        var filters = [[{ label: phrasebook.common.customer, type: "select", id: "customer_code", name: "customer_code", options: customerOptions, empty_option: true }, {
          label: phrasebook.numbers.type_of_service,
          type: "select",
          id: "service_type",
          name: "service_type",
          options: this.state.service_types,
          empty_option: true,
        }]]
      } else {
        var filters = [[{
          label: phrasebook.numbers.type_of_service,
          type: "select",
          id: "service_type",
          name: "service_type",
          options: this.state.service_types,
          empty_option: true,
        }]]
      }


      const jurisdictionOptions = this.state.jurisdictions.length > 0 ? this.state.jurisdictions.map(function (jurisdiction) {
        return { value: jurisdiction.jurisdiction, label: jurisdiction.jurisdiction };
      }) : [];
      const cityOptions = this.state.cities.length > 0 ? this.state.cities.map(function (city) {
        return { value: city.city, label: city.city };
      }) : [];

      filters.push([
        { label: phrasebook.profile.jurisdiction, type: "select", id: "jurisdiction", tooltip: phrasebook.tooltip.jurisdiction, name: "jurisdiction", options: jurisdictionOptions, empty_option: true },
        { label: phrasebook.references.city, type: "select", id: "city", name: "city", options: cityOptions, empty_option: true },
        { label: phrasebook.common.direction, type: "select", id: "direction", name: "direction", options: this.state.directions, empty_option: true }
      ],
      )

      filters.push([
        <DatePicker
          label={"From date"}
          value={this.state.fromDate}
          maxDate={moment()}
          minDate={moment().subtract(30, "days")}
          onChange={this.handlePickerChange('fromDate')}
        />,
        <DatePicker
          label={"To date"}
          value={this.state.toDate}
          maxDate={moment()}
          minDate={moment().subtract(30, "days")}
          onChange={this.handlePickerChange('toDate')}
        />
      ])
      // if (token.loggedAccountType() < 200 && this.state.customers) {
      //   const customerOptions = this.state.customers.map(function (customer) {
      //     return { value: customer['id'], label: capitalizeFirstLetter(customer['name']) };
      //   });
      //   filters.push({ label: phrasebook.common.customer, type: "select", id: "customer_id", name: "customer_id", options: customerOptions, empty_option: true })
      // }

      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)

    } else return null;
  }

  ToggleButton() {
    if (this.state.toggleData) this.setState({ toggleData: false })
    else this.setState({ toggleData: true })

  }

  ToggleData() {
    if (this.state.toggleData) return <><button class="btn btn-simple" onClick={this.ToggleButton}>See Data</button> | <button class="btn btn-faded" disabled>See Table</button></>
    else return <><button class="btn btn-faded" disabled>See Data</button> | <button class="btn btn-simple" onClick={this.ToggleButton}>See Table</button></>
  }

  ShowGraphs() {
    return <>
      <div class="row">
        <div class="col-xs-12">
          <div className="box p-1 p-sm-2">
            <h2 className="box-title pb-1 mb-1">{"Statistics"} {this.state.filters.direction ? this.state.filters.direction : null}</h2>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.call_attempts}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="callattempts" label={{ value: 'Call Attempts', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.callattempts)} />
                <Tooltip />
                <Area type="monotone" dataKey="callattempts" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.minutes}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="minutes" label={{ value: 'Minutes', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.minutes)} />
                <Tooltip />
                <Area type="monotone" dataKey="minutes" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.successful_calls}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="successfulcalls" label={{ value: 'Calls', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.successfulcalls)} />
                <Tooltip />
                <Area type="monotone" dataKey="successfulcalls" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.aloc}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="aloc" label={{ value: 'Length (min)', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.aloc)} />
                <Tooltip />
                <Area type="monotone" dataKey="aloc" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.asr}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="asr" label={{ value: 'Answers', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.asr)} />
                <Tooltip />
                <Area type="monotone" dataKey="asr" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.ner}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="ner" label={{ value: 'Efficiency', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.ner)} />
                <Tooltip />
                <Area type="monotone" dataKey="ner" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <div className="box p-1 p-sm-2">
            <h3 className="box-title pb-1 mb-1">{phrasebook.call.pdd}</h3>
            {this.state.report ?
              <AreaChart
                width={500}
                height={250}
                data={this.state.report}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis dataKey="pdd" label={{ value: 'Delay (seconds)', angle: -90, position: 'insideLeft' }} ticks={this.calculateTicks(this.state.minmax.pdd)} />
                <Tooltip />
                <Area type="monotone" dataKey="pdd" stroke="#8884d8" fill="#8884d8" />
              </AreaChart>
              : <Loader
                type="TailSpin"
                color="#00BFFF"
                height={100}
                width={100}
              />}
          </div>
        </div>
      </div>
    </>
  }

  ShowTable() {
    var labels = [
      phrasebook.common.date,
      phrasebook.call.call_attempts,
      phrasebook.call.successful_calls,
      phrasebook.call.minutes,
      phrasebook.call.aloc_abrv,
      phrasebook.call.asr_abrv,
      phrasebook.call.ner_abrv,
      phrasebook.call.pdd_abrv
    ]
    var fields = ['date', 'callattempts', 'successfulcalls', 'minutes', 'aloc', 'asr', 'ner', 'pdd'];

    var actions = [];

    return (
      <div className="box p-1 p-sm-2 my-md-1">
        <br></br>
        {this.state.report ? <Table
          values={this.state.report}
          limit={this.state.limit}
          currentPage={this.state.page}
          pageNeighbours={this.state.pageNeighbours}
          onPageChanged={this}
          nofound={phrasebook.common.nodatafound}
          headers={labels}
          keys={fields}
        /> : <Loader
          type="TailSpin"
          color="#00BFFF"
          height={100}
          width={100}
        />}
      </div>)
  }


  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.headerlinks.call_statistics} />
      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.headerlinks.call_statistics}</h2>
        {this.SearchBox()}
        {this.state.report && this.state.report.length > 0 ? <OnClickButton
          title={'Download'}
          onClick={this.handleDownload}
        /> : null}
        {this.ToggleData()}
      </div>

      {this.state.toggleData == false ? this.ShowGraphs() : this.ShowTable()}



    </>

  }
}

function mapStateToProps(state) {
  const { authentication, loggedpermissions, report, georesource, vendor, call } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    customers: vendor.vendors,
    report: report.report,
    cities: call.cities,
    jurisdictions: call.jurisdictions,
  };
}

const summary = connect(mapStateToProps)(SummaryOverview);

//export default withStyles(styles)(partnersite);
export default (summary);
